import strings from 'helper/localization/localization';
import React, { PureComponent } from 'react';

export default class SignupCompletion extends PureComponent {
  render() {
    return (
      <form>
        <p className='thanks-confirmation'>{strings.thanksWeSentConfirmation}</p>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupCompletion.jsx